define("settings/components/integrations/mavely/profiles", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--text--bold u--text--md">
    {{t "shared_words.mavely"}}
  </p>
  <p class="u--text--light u--m__b__lg">
    {{t "account.mavely.add_new"}}
  </p>
  {{#if this.profiles.length}}
    <section class="tAC--section">
      <table class="o--table tAC--table">
        <thead>
          <tr>
            <th>
              {{t "shared_words.account"}}
            </th>
            <th>
              {{t "account.controllers.groups.table_headers.status"}}
            </th>
            <th>
              {{t "shared_words.actions"}}
            </th>
          </tr>
        </thead>
        <tbody>
          {{#each this.profiles as |profile|}}
            <Integrations::Mavely::Profile @group={{@group}} @mavelyProfile={{profile}} @refresh={{this.refresh}} />
          {{/each}}
        </tbody>
      </table>
    </section>
  {{/if}}
  */
  {
    "id": "DDSO7pQm",
    "block": "[[[10,2],[14,0,\"u--text--bold u--text--md\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"shared_words.mavely\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[14,0,\"u--text--light u--m__b__lg\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"account.mavely.add_new\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"profiles\",\"length\"]],[[[1,\"  \"],[10,\"section\"],[14,0,\"tAC--section\"],[12],[1,\"\\n    \"],[10,\"table\"],[14,0,\"o--table tAC--table\"],[12],[1,\"\\n      \"],[10,\"thead\"],[12],[1,\"\\n        \"],[10,\"tr\"],[12],[1,\"\\n          \"],[10,\"th\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"shared_words.account\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"th\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"account.controllers.groups.table_headers.status\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"th\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"shared_words.actions\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"profiles\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],null,[[\"@group\",\"@mavelyProfile\",\"@refresh\"],[[30,2],[30,1],[30,0,[\"refresh\"]]]],null],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"profile\",\"@group\"],false,[\"t\",\"if\",\"each\",\"-track-array\",\"integrations/mavely/profile\"]]",
    "moduleName": "settings/components/integrations/mavely/profiles.hbs",
    "isStrictMode": false
  });
  let MavelyProfilesComponent = _exports.default = (_class = class MavelyProfilesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mavelyAuth", _descriptor, this);
      _defineProperty(this, "refresh", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (profile) {
          yield this.mavelyAuth.refresh.perform(profile);
        }
      }), null, "refresh", null));
    }
    get profiles() {
      return this.mavelyAuth.mavelyProfiles.get(this.args.group);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mavelyAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyProfilesComponent);
});